<template>
  <div>
    <isrs-settings-dialog
      :fields="fields"
      :input-form-fields-activated="configActivated"
      :input-form-data="config"
      @formDataChanged="config => saveConfig(config)"
    ></isrs-settings-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import IsrsSettingsDialog from '../../components/IsrsSettingsDialog.vue'

export default {
  components: { IsrsSettingsDialog },
  data() {
    return {
      fields: [
        {
          header: 'Suppress Label Confirmation Mail',
          label: 'Suppress Label Confirmation Mail',
          key: 'suppressConfirmationMail',
          type: Boolean
        },
        {
          header: 'Brandname',
          label: 'Brandname',
          key: 'brandName',
          type: String
        },
        {
          header: 'Average Parcel Weight (gram)',
          label: 'Average Parcel Weight per sender country. E.x.: DE:1500;GB:3000',
          key: 'averageWeightGram',
          type: String
        },
        {
          header: 'Selected Standard Return Reasons',
          label: 'Return Reasons List',
          key: 'selectedReturnReasons',
          type: 'Select-Multiple'
        },
        {
          header: 'Standard Return Reasons',
          label: 'Standard Return Reasons',
          key: 'standardReturnReasonsEnabled',
          type: Boolean
        }
      ],
      textsFields: [
        {
          label: 'Welcome Text',
          key: 'hero.headline_whitelabel',
          defaults: {
            de: 'Willkommen im {{customer}} Rücksende Portal',
            en: 'Welcome to {{customer}} return portal'
          }
        }
      ]
    }
  },

  created() {
    this.fetchConfig()
  },

  computed: {
    ...mapGetters('returnShopPortal', ['configActivated', 'config'])
  },

  methods: {
    ...mapActions('returnShopPortal', ['fetchConfig', 'saveConfig'])
  }
}
</script>



// WEBPACK FOOTER //
// Settings.vue?8ad92570